import { isEqual } from "lodash";
import { useCallback, useEffect, useState } from "react"

// Generate unique tab ID for this session
const getTabId = () => {
    if (!window.tabId) {
        window.tabId = `tab_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
    }
    return window.tabId;
};

export const useLocalStore = (key) => {
    // Create tab-specific key to isolate storage between tabs
    const tabSpecificKey = `${key}_${getTabId()}`;
    const storeData = localStorage.getItem(tabSpecificKey);
    const [data, setData] = useState();

    useEffect(() => {
        if(!isEqual(data, storeData)) {
            setData(storeData);
        }
    }, [storeData, data]);
    
    const set = useCallback((newData) => {
        if (newData) {
            localStorage.setItem(tabSpecificKey, newData);
            setData(newData);
        } else {
            localStorage.removeItem(tabSpecificKey);
            setData(undefined);
        }
    }, [tabSpecificKey])

    return { data, setData: set }
}